import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const injectOptimizations = () => {
  // Preload LCP Image
  const preloadImage = document.createElement('link');
  preloadImage.rel = 'preload';
  preloadImage.as = 'image';
  preloadImage.href = 'https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp';
  // Add imageSrcSet for responsive preloading
  preloadImage.imageSrcset = 'https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=400 400w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=800 800w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp 1080w';
  preloadImage.imageSizes = '(max-width: 768px) 90vw, 600px';
  document.head.appendChild(preloadImage);
  // Preconnect Fonts
  const preconnect1 = document.createElement('link');
  preconnect1.rel = 'preconnect';
  preconnect1.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnect1);
  const preconnect2 = document.createElement('link');
  preconnect2.rel = 'preconnect';
  preconnect2.href = 'https://fonts.gstatic.com';
  preconnect2.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect2);
  // Non-blocking Font CSS
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap';
  link.media = 'print';
  link.onload = function () {
    this.media = 'all';
  } as any;
  document.head.appendChild(link);
};
injectOptimizations();
const injectMetaPixel = () => {
  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1178622060957299');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1178622060957299&ev=PageView&noscript=1" />`;
  document.head.appendChild(noscript);
};
// Defer pixel to prioritize LCP and initial render
if (typeof window !== 'undefined') {
  setTimeout(injectMetaPixel, 2500);
}
render(<App data-id="element-313" />, document.getElementById('root'));